import { atom } from "jotai";
export const layoutAtom = atom<"content" | "default">("default");
